import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTToolbar = _resolveComponent("KTToolbar")!
  const _component_TablesWidget = _resolveComponent("TablesWidget")!
  const _component_FormModal = _resolveComponent("FormModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KTToolbar, {
      routeKey: _ctx.getKey,
      breadcrumbs: _ctx.breadcrumbs,
      title: ""
    }, null, 8, ["routeKey", "breadcrumbs"]),
    (_ctx.mapping)
      ? (_openBlock(), _createBlock(_component_TablesWidget, {
          key: 0,
          "widget-classes": "mb-5 mb-xl-8",
          routeKey: _ctx.getKey
        }, null, 8, ["routeKey"]))
      : _createCommentVNode("", true),
    (_ctx.mapping)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.mapping.map.ModalForm)
            ? (_openBlock(), _createBlock(_component_FormModal, {
                key: 0,
                routeKey: _ctx.getKey
              }, null, 8, ["routeKey"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_2
  ], 64))
}